import React, { useState, useEffect } from 'react';

import { session } from '../../../services/session';

import { Loader } from '../../misc/loader-utils';
import CreateCollectionModal from './create-collection-modal';

import CollectionsService from './collections-service';
import CollectionsTable from './collections-table';

import './styles/collections.scss';

const Collections = () => {
  const tableTabs = [
    { label: 'View by Merchant', value: 'merchant' },
    { label: 'View by Product', value: 'product' },
  ];

  const [activeTab, setActiveTab] = useState(tableTabs[0]);
  const [didMount, setDidMount] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mockData, setMockData] = useState(false);
  const [collections, setCollections] = useState(null);
  const [params, setParams] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const tabDataMap = {
    collections,
  };

  useEffect(() => {
    setDidMount(true);
  }, []);

  // TODO: set params
  useEffect(() => {
    setParams(prevState => {
      return {
        ...prevState,
      };
    });
  }, []);

  useEffect(() => {
    if (didMount) {
      setLoading(true);
      getTableData();
    }
  }, [params, mockData]);

  async function getTableData() {
    if (mockData) {
      const mockResponseData = CollectionsService.getMockData();
      setCollections(mockResponseData);
      setLoading(false);
    } else {
      try {
        const collectionsData = await CollectionsService.getCollections();
        setCollections(collectionsData.data.data);
        setLoading(false);
      } catch (error) {
        setCollections([]);
        setLoading(false);
      }
    }
  }

  function getDisplayTxt() {
    if (loading) return <h1>-</h1>;

    const dataLen = collections.length;

    const displayTxt = !dataLen ? 'No' : dataLen === 1 ? 'Displaying 1' : `Displaying ${dataLen}`;

    return <h1>{`${displayTxt} Collections`}</h1>;
  }

  const tabs = tableTabs.map((tab, idx) => {
    return (
      <span
        key={idx}
        className={`tab ${tab.value === activeTab.value ? 'active' : ''}`}
        onClick={() => setActiveTab(tab)}
      >
        <span>{tab.label}</span>
      </span>
    );
  });

  const searchBar = (
    <input className="search-bar" type="text" placeholder="Search for a Collection" />
  );

  const dummyDropDowns = (
    <div className="dropdowns">
      <div className="label">Dropdowns go here</div>
    </div>
  );

  const collectionTable = !loading ? <CollectionsTable data={collections} /> : null;

  const mocksButton = session.isAdminView ? (
    <button onClick={() => setMockData(!mockData)}>Mocks</button>
  ) : null;

  const modal = showModal ? <CreateCollectionModal setShowModal={setShowModal} /> : null;

  return (
    <div className="collections-overview-container">
      <Loader loading={loading} />
      <h1>Collections</h1>
      {modal}
      <div className="tabs">
        {tabs}
        <button className="show-modal-btn" onClick={() => setShowModal(true)}>
          Create Collection
        </button>
      </div>
      <div className="under-tab-bar">
        {searchBar}
        {/* TODO: Dropdowns */}
        {dummyDropDowns}
      </div>
      <div className="header">
        <div className="toggles">
          {getDisplayTxt()}
          {mocksButton}
        </div>
      </div>
      {collectionTable}
    </div>
  );
};

export default Collections;
